import script from "./PreViewImg.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreViewImg.vue?vue&type=script&lang=ts&setup=true"

import "./PreViewImg.vue?vue&type=style&index=0&id=35b7a061&lang=scss"

const __exports__ = script;

export default __exports__